const MODAL_TITLE = "Filters";
const OK_BUTTON_TEXT = "Apply";

export { MODAL_TITLE, OK_BUTTON_TEXT };
